import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {useMember} from 'src/feature/members/hook'
import {useEffect, useState} from 'react'
import PackageDetail from './PackageDetail'
import FilterDrawerPackages from '../List/FilterDrawerPackages'

const MemberDetailPackages = ({loading}: {loading: boolean; search: string; setSearch: any}) => {
  const intl = useIntl()
  const [isDetail, setIsDetail] = useState({
    status: false,
    packageId: '',
  })

  const {detailTab, listFilterPackage, listFilterPackageSet} = useMember()
  const [open, setOpen] = useState(false)

  const data = detailTab?.Packages?.dataList
  const paging = detailTab?.Packages?.paging || {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'name',
      dataIndex: 'name',
      title: 'Membership/Product Name',
    },
    {
      key: 'amount',
      dataIndex: 'amount',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.PACKAGE.AMOUNT'}),
      customMonetize: true,
    },
    {
      key: 'subscriptionOption',
      dataIndex: 'subscriptionOption',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.PACKAGE.SUBSCRIPTION_OPTION'}),
      render: (text: number | null) => {
        switch (text) {
          case 1:
            return <>Monthly</>
          case 2:
            return <>Annually</>
          case 3:
            return <>One Time</>
          default:
            return <>-</>
        }
      },
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.PACKAGE.STATUS'}),
      render: (text: number) => {
        let color = 'text-success'
        let label = 'Active'
        switch (text) {
          case 1:
            color = 'text-success'
            label = 'Active'
            break
          case 2:
            color = 'text-error'
            label = 'Inactive'
            break
          case 3:
            color = 'text-warning'
            label = 'Preactive'
            break
          case 4:
            color = 'text-error'
            label = 'Cancel'
            break
          case 5:
            color = 'text-error'
            label = 'Expired'
            break
          default:
            color = 'text-warning'
            label = 'Preactive'
            break
        }

        return <span className={color}>{label}</span>
      },
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.ACTION'}),
      render: (id: any) => (
        <button
          className='btn btn-link text-primary'
          onClick={() => setIsDetail({status: true, packageId: id})}
        >
          {intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.DETAIL'})}
        </button>
      ),
    },
  ]

  const getuserIDParam = () => {
    const path = window.location.pathname
    const pathParts = path.split('/')
    const userID = pathParts[pathParts.length - 1]
    return userID
  }

  useEffect(() => {
    if (
      listFilterPackage?.filterList?.length > 0 ||
      listFilterPackage?.paging?.currentPageNumber > 1
    ) {
      listFilterPackageSet({
        ...listFilterPackage,
        filterList: [],
        paging: {
          ...listFilterPackage.paging,
          currentPageNumber: 1,
          pageSize: listFilterPackage.paging.pageSize,
        },
      })
    }
  }, [])

  return (
    <>
      {isDetail.status ? (
        <PackageDetail isDetail={isDetail} setIsDetail={setIsDetail} data={data} />
      ) : (
        <div>
          <FilterDrawerPackages memberId={getuserIDParam()} setOpen={setOpen} open={open} />
          <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
            <div className='card-header'>
              <div className='card-title m-0'>
                <div>
                  <h3 className='fw-bold mb-2 mt-5'>Memberships/Products</h3>
                  <p className='text-muted fw-normal fs-6'>
                    {intl.formatMessage({id: 'MEMBER.DETAIL.PACKAGES_TOOLTIP'})}
                  </p>
                </div>
              </div>
            </div>
            <div className='card-body pt-0'>
              <div className='table-responsive'>
                <Table
                  loading={loading}
                  dataSource={data}
                  tableName={'memberPackages'}
                  columns={Columns}
                  pagination={{
                    current: paging.currentPageNumber,
                    pageSize: paging.pageSize,
                    total: paging.totalCount,
                    onChange: (page: any) => {
                      if (!detailTab || !detailTab.Packages) return
                      const {pageSize, current} = page
                      const currentPage =
                        pageSize !== detailTab.Packages.paging.pageSize ? 1 : current

                      listFilterPackageSet({
                        ...listFilterPackage,
                        paging: {
                          ...listFilterPackage.paging,
                          pageSize,
                          currentPageNumber: currentPage,
                        },
                      })
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MemberDetailPackages
